type ClockTimes = {
    browserTime: Date;
    serverTime: Date;
};

type UnitAmount = {
    unit: string;
    amount: number;
};

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

// Months and years are approximated, so the text is a rough size, not a calendar distance
const UNITS = [
    { unit: 'year', ms: 365 * DAY_MS },
    { unit: 'month', ms: 30 * DAY_MS },
    { unit: 'day', ms: DAY_MS },
    { unit: 'hour', ms: HOUR_MS },
    { unit: 'minute', ms: MINUTE_MS },
    { unit: 'second', ms: SECOND_MS },
];

const splitIntoUnits = (differenceMs: number): UnitAmount[] => {
    const { amounts } = UNITS.reduce(
        ({ amounts, restMs }, { unit, ms }) => {
            const amount = Math.floor(restMs / ms);

            return { amounts: [...amounts, { unit, amount }], restMs: restMs - amount * ms };
        },
        { amounts: [] as UnitAmount[], restMs: Math.abs(differenceMs) },
    );

    return amounts.filter(({ amount }) => amount > 0);
};

const formatUnitAmount = ({ unit, amount }: UnitAmount) => {
    return `${amount} ${unit}${amount === 1 ? '' : 's'}`;
};

export const formatClockDifference = ({ browserTime, serverTime }: ClockTimes) => {
    const amounts = splitIntoUnits(browserTime.getTime() - serverTime.getTime());
    const direction = browserTime < serverTime ? 'behind' : 'ahead';

    return `${amounts.map(formatUnitAmount).join(' ')} ${direction}`;
};
